import { type GQLCustomUITunnelDefinition } from '../graphql/types';
import { createAtlAttributionHeader } from '../../utils';
import { useLazyLoadQuery, graphql } from 'react-relay';
import type { useCustomUITunnelsListRelay_forge_ui_Query as ActiveTunnelsRelayQuery } from './__generated__/useCustomUITunnelsListRelay_forge_ui_Query.graphql';

export type UseAppTunnelsRelayOptions = {
	appId: string;
	contextIds?: string[];
	environmentId: string;
};

export interface UseAppTunnelsHookResult {
	loading: boolean;
	tunnels: GQLCustomUITunnelDefinition[];
}

export interface AppTunnelsGQLResult {
	data?: {
		appActiveTunnels?: {
			customUI?: Array<GQLCustomUITunnelDefinition>;
		};
	};
	loading: boolean;
}

export const getCustomUITunnelsFromGQLResult = ({
	loading,
	data,
}: AppTunnelsGQLResult): GQLCustomUITunnelDefinition[] | undefined => {
	if (!loading) {
		return data?.appActiveTunnels?.customUI;
	}

	return undefined;
};

export const useCustomUITunnelsListRelay = (
	options: UseAppTunnelsRelayOptions,
): UseAppTunnelsHookResult => {
	const { appId, environmentId } = options;
	const contextIds = options.contextIds ?? [];

	/* eslint-disable @atlassian/relay/unused-fields, @atlassian/relay/no-wrapping-hooks */
	const data = useLazyLoadQuery<ActiveTunnelsRelayQuery>(
		graphql`
			query useCustomUITunnelsListRelay_forge_ui_Query($appId: ID!, $environmentId: ID!) {
				appActiveTunnels(appId: $appId, environmentId: $environmentId) {
					customUI {
						resourceKey
						tunnelUrl
					}
				}
			}
		`,
		{
			appId,
			environmentId,
		},
		{
			networkCacheConfig: {
				metadata: {
					headers: {
						'atl-attribution': createAtlAttributionHeader([...contextIds].sort().join()),
					},
				},
			},
		},
	);
	/* eslint-enable @atlassian/relay/unused-fields, @atlassian/relay/no-wrapping-hooks */

	const tunnels = (data?.appActiveTunnels?.customUI ?? []) as GQLCustomUITunnelDefinition[];

	return {
		tunnels,
		loading: false,
	};
};
